import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithAuth } from "services/common/rtkQueryConfig";

export const verificationApi = createApi({
  reducerPath: "verificationApi",
  baseQuery: baseQueryWithAuth,
  tagTypes: ["OnlineVerification"],
  endpoints: (build) => ({
    createVerificationOrder: build.mutation<VerificationOrder, CreateVerificationOrder>({
      query: (body: CreateVerificationOrder) => ({
        url: "/Verification/createOrder",
        method: "POST",
        body,
      }),
      invalidatesTags: ["OnlineVerification"],
    }),
    getSsoUrl: build.query<SsoUrl, string>({
      query: (orderId) => `/Verification/ssoUrl/${orderId}`,
      providesTags: ["OnlineVerification"],
    }),
  }),
});
export const { useCreateVerificationOrderMutation, useGetSsoUrlQuery } = verificationApi;

export interface CreateVerificationOrder {
  email: string;
  last4SSN?: string;
  nhDealapplicationId: string;
  applicationId: string;
  firstName?: string;
  lastName?: string;
  phoneNumber?: string;
  notificationUrl?: string;
  returnUrl?: string;
  employerName?: string;
  ssn?: string;
  dateOfBirth?: string;
  address?: BorrowerAddress;
  consentTS: string;
  verificationType: string;
  isPrimary: boolean;
}

export type VerificationType = "VOI" | "VOA";

interface VerificationOrder extends CreateVerificationOrder {
  id: string;
  created: Date;
  isArchived: boolean;
  status: string;
  loginUrl: string;
  daysRemaining: number;
  employmentVerificationRequested: boolean;
}

interface SsoUrl {
  url: string;
}
interface BorrowerAddress {
  street?: string;
  street2?: string;
  city?: string;
  state?: string;
  zip?: string;
}
